import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';

import styles from './styles/ShopList.scss';
import { Link } from 'dibs-elements/exports/Link';

function ShopListComponent({ landingPage }) {
    const list = landingPage.list || {};
    return (
        <Fragment>
            {!!list.title && <h3 className={styles.title}>{list.title}</h3>}
            {(list.listGroups || []).map((group, i) => {
                const groupTnSuffix = (group.title || '').toLowerCase().replace(/ /g, '-');
                const items = group.listItems || [];
                if (!items.length) {
                    return null;
                }
                return (
                    <Fragment key={i}>
                        <h3 className={styles.groupTitle} data-tn={`title-${groupTnSuffix}`}>
                            {group.title}
                        </h3>
                        <ul data-tn={`shop-list-group-${groupTnSuffix}`} className={styles.list}>
                            {items.map(item => {
                                if (!item.url) {
                                    return null;
                                }
                                const tnSuffix = (item.title || '')
                                    .toLowerCase()
                                    .replace(/ /g, '-');
                                return (
                                    <li key={item.url} className={styles.listItem}>
                                        <Link
                                            className={styles.link}
                                            href={item.url}
                                            dataTn={`shop-list-${tnSuffix}`}
                                        >
                                            <span className={styles.imageWrapper}>
                                                <img
                                                    className={styles.image}
                                                    src={item.imageUrl}
                                                    alt={item.title}
                                                />
                                            </span>
                                            <span className={styles.itemTitle}>{item.title}</span>
                                        </Link>
                                    </li>
                                );
                            })}
                        </ul>
                    </Fragment>
                );
            })}
        </Fragment>
    );
}

ShopListComponent.propTypes = {
    landingPage: PropTypes.object.isRequired,
};

export const ShopList = createFragmentContainer(ShopListComponent, {
    landingPage: graphql`
        fragment ShopList_landingPage on LandingPage {
            list {
                title
                listGroups {
                    title
                    listItems {
                        imageUrl
                        title
                        url
                    }
                }
            }
        }
    `,
});
